import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { TOKEN_NAME } from '@constants/global';
import { CookieService } from 'ngx-cookie-service';
import { sanitizeReturnUrl } from './return-url.util';

export const publicGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
	const cookieService = inject(CookieService);
	const router = inject(Router);

	if (!cookieService.check(TOKEN_NAME)) {
		return true;
	}

	const target = sanitizeReturnUrl(route.queryParamMap.get('returnUrl'));
	return router.parseUrl(target);
};